var config = require('../config.js')
module.exports = {
    mallCategoryList: config.host + '/mallCenter/api/v1/mallCategory/list/c', //商品分类
    mallGoodsList: config.host + '/mallCenter/api/v1/mallGoods/list/c', //商品类别
    mallGoodsDetail: config.host + '/mallCenter/api/v1/mallGoods/getDetail/c', //商品详情
    mallAddressDetail: config.host + '/mallCenter/api/v1/address/detail/c', //自提地址


    
    mallOrderCancel: config.host + '/mallCenter/api/v1/mallOrder/cancelOrder/c', //取消订单
    mallOrderConfirmOrderInfo: config.host + '/mallCenter/api/v1/mallOrder/confirmOrderInfo/c', //确认订单
    mallOrderConfirmReceipt: config.host + '/mallCenter/api/v1/mallOrder/confirmReceipt/c', //确认收货
    mallOrderConfirmShipment: config.host + '/mallCenter/api/v1/mallOrder/confirmShipment/c', //确认自提
    mallOrderGetDetail: config.host + '/mallCenter/api/v1/mallOrder/getDetail/c', //订单详情
    mallOrderList: config.host + '/mallCenter/api/v1/mallOrder/list/c', //订单列表
    mallOrderStartPay: config.host + '/mallCenter/api/v1/mallOrder/start_pay/c', //开始支付
    mallOrderSubmitOrder: config.host + '/mallCenter/api/v1/mallOrder/submitOrder/c', //提交订单
    mallOrderRefundListByOrderId: config.host + '/mallCenter/api/v1/mallOrderRefund/getRefundListByOrderId/c', //退货订单
    mallOrderRefundSaveLogisticsInfo: config.host + '/mallCenter/api/v1/mallOrderRefund/saveLogisticsInfo/c', //退货订单

}